import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';

import { Audience } from '../model/audience';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AudienceService {
  serviceUrl = '/api/audiences';
  headers: Headers;

  constructor(private http: Http, private authService: AuthenticationService) {
  }

  private addToken(){
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.headers = new Headers(
      {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + <string>(currentUser && currentUser.token)
      });
  }

  getAudiencesWithTokenRefresh(): Observable<Audience[]> {
    return this.authService.checkAndRefreshToken()
      .flatMap((result: boolean) => {
        return this.getAudiences();
      });
  }

  getAudiences(): Observable<Audience[]> {
    this.addToken();
    return this.http.get(this.serviceUrl, { headers: this.headers })
      .map((response: Response) => {
          return <Audience[]>response.json();
      })
      .catch(this.handleError);
  }

  createAudience(audienceName: string): Observable<Audience> {
    this.addToken();
    return this.http.post(this.serviceUrl, '"' + audienceName + '"', { headers: this.headers } )
      .map((response: Response) => {
        return <Audience>response.json();
      })
      .catch(this.handleError);
  }

  deleteAudience(audienceId: string): Observable<Response> {
    this.addToken();
    return this.http.delete(this.serviceUrl + '/' + audienceId, { headers: this.headers })
      .map(response => response)
      .catch(this.handleError);
  }

  updateAudience(audience: Audience): Observable<Audience> {
    this.addToken();
    return this.http.put(this.serviceUrl + '/' + audience.ClientId, audience, { headers: this.headers })
      .map((response: Response) => {
        return <Audience>response.json();
      })
      .catch(this.handleError);
  }

  createNewSecret(audienceId: string): Observable<Audience> {
    this.addToken();
    return this.http.post(this.serviceUrl + '/createnewsecret/' + audienceId, null, { headers: this.headers })
      .map((response: Response) => {
        return <Audience>response.json();
      })
      .catch(this.handleError);
  }

  handleError(error: Response) {
    console.error('AudienceService error', error);
    return Observable.throw(error.json().error || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/audience.service.ts